/*
  商品の一覧（snippets/product-listing.liquid）の絞り込み・並び替え・タブ
  コレクションページ（sections/collection-template.liquid）と検索結果（sections/search-template.liquid）で使う
  - 絞り込み：PC は選んだらすぐ反映。タブレット・SP は下から出るシートで選び「N件を表示」で反映
    件数は section_id（[data-coll-page] の data-section-id）で先に取得し、[data-coll-count] から読む
  - 価格は帯（coll_price）で選び、URL の filter.v.price.gte / lte に変換
  - 並び替え・タブは今の URL の条件（検索語 q など）を残して書き換える
*/
(function () {
  var root = document.querySelector('[data-coll-page]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var form = root.querySelector('[data-coll-form]');
  var sheet = root.querySelector('[data-coll-sheet]');
  var backdrop = root.querySelector('.coll-backdrop');
  var applyBtn = root.querySelector('[data-coll-apply]');
  var openBtn = root.querySelector('[data-coll-open]');
  var sheetQuery = window.matchMedia('(max-width: 959px)');

  // ---------- URL を組み立てる ----------
  function priceGroup() {
    return form && form.querySelector('[data-coll-price]');
  }

  function formUrl() {
    var params = [];
    new FormData(form).forEach(function (value, key) {
      if (key === 'coll_price' || value === '') return;
      params.push([key, value]);
    });
    var group = priceGroup();
    var band = form.querySelector('[name="coll_price"]:checked');
    if (group && band && band.value) {
      var range = band.value.split('-');
      if (range[0]) params.push([group.getAttribute('data-min-name'), range[0]]);
      if (range[1]) params.push([group.getAttribute('data-max-name'), range[1]]);
    }
    return toUrl(form.getAttribute('action'), params);
  }

  function toUrl(path, params) {
    var query = params.map(function (p) {
      return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
    }).join('&');
    return path + (query ? '?' + query : '');
  }

  function currentParams() {
    var params = [];
    new URLSearchParams(location.search).forEach(function (value, key) {
      if (key !== 'page') params.push([key, value]);
    });
    return params;
  }

  // 価格帯のボタンを、今の URL に合わせる
  (function () {
    var group = priceGroup();
    if (!group) return;
    var search = new URLSearchParams(location.search);
    var value = (search.get(group.getAttribute('data-min-name')) || '') + '-' + (search.get(group.getAttribute('data-max-name')) || '');
    if (value === '-') value = '';
    var radio = form.querySelector('[name="coll_price"][value="' + value + '"]');
    if (radio) radio.checked = true;
  })();

  // ---------- 並び替え ----------
  var sortSelect = root.querySelector('[data-coll-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var params = currentParams().filter(function (p) {
        return p[0] !== 'sort_by';
      });
      params.unshift(['sort_by', sortSelect.value]);
      location.href = toUrl(location.pathname, params);
    });
  }

  // ---------- タブ：ほかの条件（価格など）は残して、キャラクター・種類だけ入れ替える ----------
  var tabs = root.querySelector('[data-coll-tabs]');
  if (tabs) {
    // SP は横スクロールなので、選択中のタブが見えるところまで動かす
    var currentTab = tabs.querySelector('.is-current');
    if (currentTab && tabs.scrollWidth > tabs.clientWidth) {
      tabs.scrollLeft = Math.max(0, currentTab.offsetLeft - 16);
    }

    var tabPairs = [];
    try {
      tabPairs = JSON.parse(tabs.getAttribute('data-coll-tabs')).filter(Boolean);
    } catch (e) {
      tabPairs = [];
    }
    tabs.addEventListener('click', function (evt) {
      var tab = evt.target.closest('[data-coll-tab]');
      if (!tab) return;
      evt.preventDefault();
      var params = currentParams().filter(function (p) {
        return !tabPairs.some(function (pair) {
          return pair[0] === p[0] && pair[1] === p[1];
        });
      });
      if (tab.hasAttribute('data-coll-tab-param')) {
        params.push([tab.getAttribute('data-coll-tab-param'), tab.getAttribute('data-coll-tab-value')]);
      }
      location.href = toUrl(location.pathname, params);
    });
  }

  // ---------- 絞り込み ----------
  function openSheet() {
    sheet.classList.add('is-open');
    backdrop.hidden = false;
    document.documentElement.classList.add('coll-sheet-open');
    openBtn.setAttribute('aria-expanded', 'true');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    var close = sheet.querySelector('.coll-filter__close');
    if (close) close.focus();
  }

  function closeSheet() {
    sheet.classList.remove('is-open');
    backdrop.hidden = true;
    document.documentElement.classList.remove('coll-sheet-open');
    openBtn.setAttribute('aria-expanded', 'false');
    sheet.removeAttribute('role');
    sheet.removeAttribute('aria-modal');
    openBtn.focus();
  }

  // シートで選んでいる間は、件数だけ先に調べてボタンに出す
  var countRequest = 0;
  function previewCount() {
    var id = ++countRequest;
    var url = formUrl();
    applyBtn.disabled = true;
    fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        if (id !== countRequest) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var page = doc.querySelector('[data-coll-count]');
        var count = page ? page.getAttribute('data-coll-count') : null;
        applyBtn.textContent = count !== null ? count + '件を表示' : 'この条件で表示';
        applyBtn.disabled = false;
      })
      .catch(function () {
        if (id !== countRequest) return;
        applyBtn.textContent = 'この条件で表示';
        applyBtn.disabled = false;
      });
  }

  if (form) {
    form.addEventListener('change', function () {
      if (sheetQuery.matches) {
        previewCount();
      } else {
        location.href = formUrl();
      }
    });
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      location.href = formUrl();
    });
    applyBtn.addEventListener('click', function () {
      location.href = formUrl();
    });
    openBtn.addEventListener('click', openSheet);
    root.querySelectorAll('[data-coll-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  }

  // ---------- SP のバーを、固定されたヘッダーの下に止める ----------
  var header = document.getElementById('header');
  function updateStickyTop() {
    var top = header && header.classList.contains('header__fix') ? header.offsetHeight : 0;
    root.style.setProperty('--coll-sticky-top', top + 'px');
  }
  window.addEventListener('scroll', updateStickyTop, { passive: true });
  updateStickyTop();

})();
